import script from "./HandleRiskItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandleRiskItem.vue?vue&type=script&setup=true&lang=ts"

import "./HandleRiskItem.vue?vue&type=style&index=0&id=35c59639&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c59639"]])

export default __exports__